<div *ngIf="!DBservice.ismobile && false" class="header__ d__flex just-s" >
  <h2 class="fnt-20  myAccount-titles" >View Category</h2>
  <ion-button class="close_button" routerLink="/categorylist" fill="clear" size="small"><span class="span"><ion-icon name="close-outline" ></ion-icon></span>Close</ion-button>
</div>

<ion-grid class="container" fixed *ngIf="false" >
  <form #categoryForm="ngForm" novalidate>
    <div class="page_border">
      <h3 class="page_header">Category Info</h3>
      <ion-item>
        <ion-label color="grey" position="floating">Category Name</ion-label>
        <ion-input [(ngModel)]="category.category_name" name="category_name" type="text" #category_name="ngModel" spellcheck="false" autocapitalize="off" required></ion-input>
      </ion-item>
      <p class="l1 s1" ion-text [hidden]="category.category_name || submitted == false">
        Enter the Category name
      </p>
      <ion-row>
        <ion-col size="6" class="p0 br bb">
          <ion-item lines=none>
            <ion-label color="grey" position="floating">Display Order </ion-label>
            <ion-input [(ngModel)]="category.display_order" name="display_order" type="text"></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="6" class="p0 bb">
          <ion-item lines=none>
            <ion-label color="grey" position="floating">Product Image Size </ion-label>
            <ion-input [(ngModel)]="category.product_image_size" name="product_image_size" type="text"></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="4" class="p0 br bb">
          <ion-item lines=none>
            <ion-label color="grey">
              Is Active?
              <!-- <span class="err">*</span> -->
            </ion-label>
            <ion-checkbox class="check__box" name="category.is_active" [(ngModel)]="category.is_active"></ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="8" class="p0 bb">
          <ion-item lines=none>
            <ion-label color="grey">
              Display Home Page
              <!-- <span class="err">*</span> -->
            </ion-label>
            <ion-checkbox class="check__box" name="category.display_home_page" [(ngModel)]="category.display_home_page"></ion-checkbox>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6" class="p0 br">
          <ion-item lines=none>
            <ion-label class="white_space" color="grey">
              Show Attributes in List Page
              <!-- <span class="err">*</span> -->
            </ion-label>
            <ion-checkbox class="check__box" name="category.show_attributes_inline" [(ngModel)]="category.show_attributes_inline"></ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="6" class="p0 br">
          <ion-item lines=none>
            <ion-label color="grey" position="floating">Default View </ion-label>
            <ion-select name="default_view" [(ngModel)]="category.default_view" [ngModelOptions]="{standalone: true}">
              <ion-select-option value="Grid View">Grid View</ion-select-option>
              <ion-select-option value="List View">List View</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
    </div>
    <div class="page_border">
      <div>
        <ion-label class="img_header" color="gray" stacked>Category Image</ion-label>
      </div>
      <div (click)="selectImageSource()" class="image_box">
        <ion-icon name="camera-outline"></ion-icon>
      </div>
      <br>
     <!--  <div>
        <ion-label class="img_header" color="gray" stacked>Mobile Image</ion-label>
      </div>
      <div (click)="selectImageSource()" class="image_box">
        <ion-icon name="camera-outline"></ion-icon>
      </div>
      <br> -->
    </div>
  </form>
</ion-grid>

<!-- Dybamic form -->

<div [class.d__flex]="!DBservice.ismobile" class='m-55'>
  <!-- <div class="side-bar">
    <div class="side-bar-options cursor-pointer" *ngFor="let item of sidebar" [id]="item.name" [class.active]="current_value == item.name" (click)="current_value = item.name" (click)="goto_center(current_value)">
      <div>{{item.title}}</div>
    </div>
  </div> -->
  <div class="flex-1  background">
    <app-dynamic-form [myform]="category" [form_values]="category_detail" [box_width]="DBservice.ismobile ? '100%': '50%'"  [submitted]="submitted" [form_data]="form_data" [current_value]="current_value"></app-dynamic-form>
  </div>
</div>
<ion-footer  class="footer">
  <form>
    <ion-toolbar>
      <ion-button *ngIf="title == 'Add'" type="submit" (click)="close_category(category)" expand="block">Add Category</ion-button>
      <ion-button *ngIf="title == 'Edit'" type="submit" (click)="close_category(category)" expand="block">Update Category</ion-button>
      <!-- <ion-button *ngIf="title == 'Add'" type="submit" (click)="close_category(categoryForm)" expand="block">Add Category</ion-button>
      <ion-button *ngIf="title == 'Edit'" type="submit" (click)="close_category(categoryForm)" expand="block">Update Category</ion-button> -->
    </ion-toolbar>
  </form>
</ion-footer>